import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { Ng1LoadedGuard } from '../shared/ng1/ng1-loaded.guard';
import { CallHistoryListComponent } from './call-history-list/call-history-list.component';
import { CallHistoryComponent } from './call-history.component';
import { CallHistoryResolve } from './call-history.resolve';
import { UsersSimplifiedResolve } from '../phone-numbers/users/usersSimplified.resolve';
import { HistoricalMsisdnResolver } from '../shared/msisdn/historical-msisdn.resolver';

const routes: Routes = [
  {
    path: 'call-history',
    component: CallHistoryComponent,
    canActivate: [Ng1LoadedGuard],
    canLoad: [NgxPermissionsGuard],
    children: [
      {
        path: '',
        component: CallHistoryListComponent,
        resolve: {
          msisdns: HistoricalMsisdnResolver,
          users: UsersSimplifiedResolve,
          callHistory: CallHistoryResolve
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CallHistoryRoutingModule {}
